import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'reduxStore';

export const selectStreamTracker = (state: RootState) => state.streamTracker;

export const selectBranchId = createSelector(selectStreamTracker, state => {
  if (state.branchId) {
    return state.branchId;
  }

  return 'main';
});

export const selectSequenceId = createSelector(
  selectStreamTracker,
  state => state.lastKnownSequence,
);

export const selectTrackingInfo = createSelector(selectStreamTracker, state => {
  return {
    branchId: state.branchId ?? 'main',
    sequenceId: state.lastKnownSequence,
  };
});
